import { useTranslation } from 'react-i18next'
import type { QuickSuggestionProps } from 'shared'

export function QuickSuggestions({
  suggestions,
  onSelect,
  disabled,
}: QuickSuggestionProps) {
  const { t } = useTranslation('common')

  return (
    <div className="flex flex-wrap gap-1.5 sm:gap-2 justify-center">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion.id}
          onClick={() => onSelect(suggestion.messageKey)}
          disabled={disabled}
          className="px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm bg-white hover:bg-[#DF631E]/5 text-[#4E2118] transition-colors disabled:opacity-50 shadow-sm border border-[#4E2118]/10 hover:border-[#DF631E]/30"
        >
          {t(suggestion.labelKey)}
        </button>
      ))}
    </div>
  )
}
